module.exports = __webpack_public_path__ + "img/43.0c3a59e1.jpg";